import React, { useEffect, useState } from "react";
import { authApi } from "../api";

const TransactionLedger = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    authApi.get("/inventory/transactions", { params: { page: 1, per_page: 100 } })
      .then((res) => setRows(res.data?.data || []))
      .catch((e) => setError(e?.response?.data?.error || "Failed to load transaction ledger"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="h-full overflow-y-auto bg-slate-50 p-4 md:p-6">
      <h1 className="text-xl md:text-2xl font-bold text-slate-800">Transaction Ledger</h1>
      {error && <div className="mt-3 rounded-lg border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm">{error}</div>}
      {loading ? (
        <div className="mt-4 space-y-2">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="h-12 bg-slate-200 rounded animate-pulse" />)}
        </div>
      ) : (
        <div className="mt-4 bg-white border border-slate-200 rounded-xl shadow-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 uppercase text-xs">
              <tr>
                <th className="px-4 py-3 text-left">Date</th>
                <th className="px-4 py-3 text-left">Type</th>
                <th className="px-4 py-3 text-left">Material</th>
                <th className="px-4 py-3 text-right">Qty</th>
                <th className="px-4 py-3 text-left">Batch</th>
                <th className="px-4 py-3 text-left">Reference</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="px-4 py-3">{(r.created_at || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="px-4 py-3">{r.transaction_type}</td>
                  <td className="px-4 py-3">{r.material_name}</td>
                  <td className="px-4 py-3 text-right">{Number(r.quantity || 0).toFixed(3)} {r.unit}</td>
                  <td className="px-4 py-3 font-mono">{r.batch_code}</td>
                  <td className="px-4 py-3">{r.reference_doc || r.context_note}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan="6" className="px-4 py-8 text-center text-slate-400">No transactions found.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TransactionLedger;
